// Shared react-select helpers for multi-select dropdowns.
//
// Spread `checkboxMultiProps` onto any <Select isMulti> to:
//   - render a checkbox next to each option, and
//   - keep the menu OPEN after each pick (so choosing a value doesn't close
//     the list every time).
//
// Usage:
//   import { checkboxMultiProps } from "./utils/MultiSelectCheckbox";
//   <Select isMulti {...checkboxMultiProps} options={...} value={...} onChange={...} />

import React from "react";
import { components } from "react-select";

// Option row with a leading checkbox reflecting the selected state.
const CheckboxOption = (props) => (
    <components.Option {...props}>
        <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
            style={{ marginRight: 8, cursor: "pointer", verticalAlign: "middle" }}
        />
        <span style={{ verticalAlign: "middle" }}>{props.label}</span>
    </components.Option>
);

export const checkboxMultiProps = {
    closeMenuOnSelect: false,   // keep the list open while picking multiple
    hideSelectedOptions: false, // keep chosen rows visible (so the tick shows)
    components: { Option: CheckboxOption },
};

export default checkboxMultiProps;
